module.exports = __webpack_public_path__ + "static/icons/icon-reef--red-b49afaa35ed6897a074930ddd4e126e9.svg";